// Copyright (c) 2020-2026 Life and Soft

export const GET_ERRORS = "GET_ERRORS";
export const USER_LOADING = "USER_LOADING";
export const SET_CURRENT_USER = "SET_CURRENT_USER";

export const INIT_CONFIGURATION = "INIT_CONFIGURATION";
export const SET_CONFIGURATION = "SET_CONFIGURATION";
